<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="productDetailSpecInfo.specs" border style="width: 100%" size="small">
        <el-table-column prop="specName" label="规格名称" align="center" />
        <el-table-column prop="stock" label="库存" align="center" />
        <el-table-column prop="sales" label="销量" align="center" />
        <el-table-column prop="price" label="金额/积分" align="center" />
        <el-table-column prop="costPrice" label="成本价" align="center" />
        <el-table-column prop="ownerPrice" label="业主价" align="center" />
        <el-table-column prop="vipPrice" label="会员价格" align="center" />
        <el-table-column prop="otPrice" label="市场价" align="center" />
        <el-table-column prop="deduction" label="抵扣金" align="center" />
        <el-table-column prop="barCode" label="条形码" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryProduct } from '@/api/goods/productApi'

export default {
  name: 'ProductDetailSpec',
  data() {
    return {
      productDetailSpecInfo: {
        specs: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailSpecInfo.productId = params.productId
      this.loadProductDetailSpecData()
    },
    async loadProductDetailSpecData() {
      const res = await queryProduct({
        productId: this.productDetailSpecInfo.productId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize,
        shopId: getShopId()
      })
      const data = res.data[0]
      const productSpecValues = data.productSpecValues || []

      productSpecValues.forEach(item => {
        const productSpecDetails = item.productSpecDetails || []
        let specValue = ''
        productSpecDetails.forEach(detail => {
          specValue += (detail.detailValue + "/")
        })
        item.specValue = specValue
      })

      this.productDetailSpecInfo.specs = productSpecValues
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailSpecData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>